import React from 'react';
import ListStory from '../../components/ListStory/ListStory';

const ShowStories = () => {
  return <ListStory page={1} type="showstories" />;
};

export default ShowStories;
